var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.973,
    height: 13.973,
    viewBox: "0 0 13.973 13.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3217",
    "data-name": "Group 3217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3216",
    "data-name": "Group 3216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40916",
    "data-name": "Path 40916",
    d: "M12.475,1.5h-1.5V.5a.5.5,0,1,0-1,0v1H3.992V.5a.5.5,0,1,0-1,0v1H1.5A1.5,1.5,0,0,0,0,2.994v9.481a1.5,1.5,0,0,0,1.5,1.5H12.475a1.5,1.5,0,0,0,1.5-1.5V2.994A1.5,1.5,0,0,0,12.475,1.5Zm.5,10.978a.5.5,0,0,1-.5.5H1.5a.5.5,0,0,1-.5-.5V5.988H12.974Zm0-7.485H1v-2a.5.5,0,0,1,.5-.5h1.5v1a.5.5,0,0,0,1,0v-1H9.98v1a.5.5,0,1,0,1,0v-1h1.5a.5.5,0,0,1,.5.5v2Z",
    fill: "CurrentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3219",
    "data-name": "Group 3219",
    transform: "translate(2.495 6.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40917",
    "data-name": "Path 40917",
    d: "M86.83,238.933h-1a.5.5,0,1,0,0,1h1a.5.5,0,1,0,0-1Z",
    transform: "translate(-85.333 -238.933)",
    fill: "CurrentColor"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3221",
    "data-name": "Group 3221",
    transform: "translate(5.988 6.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3220",
    "data-name": "Group 3220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40918",
    "data-name": "Path 40918",
    d: "M206.3,238.933h-1a.5.5,0,1,0,0,1h1a.5.5,0,1,0,0-1Z",
    transform: "translate(-204.8 -238.933)",
    fill: "CurrentColor"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3223",
    "data-name": "Group 3223",
    transform: "translate(9.481 6.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40919",
    "data-name": "Path 40919",
    d: "M325.764,238.933h-1a.5.5,0,1,0,0,1h1a.5.5,0,0,0,0-1Z",
    transform: "translate(-324.267 -238.933)",
    fill: "CurrentColor"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3225",
    "data-name": "Group 3225",
    transform: "translate(2.495 8.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3224",
    "data-name": "Group 3224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40920",
    "data-name": "Path 40920",
    d: "M86.83,307.2h-1a.5.5,0,1,0,0,1h1a.5.5,0,1,0,0-1Z",
    transform: "translate(-85.333 -307.2)",
    fill: "CurrentColor"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227",
    transform: "translate(5.988 8.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40921",
    "data-name": "Path 40921",
    d: "M206.3,307.2h-1a.5.5,0,1,0,0,1h1a.5.5,0,1,0,0-1Z",
    transform: "translate(-204.8 -307.2)",
    fill: "CurrentColor"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3229",
    "data-name": "Group 3229",
    transform: "translate(9.481 8.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40922",
    "data-name": "Path 40922",
    d: "M325.764,307.2h-1a.5.5,0,1,0,0,1h1a.5.5,0,0,0,0-1Z",
    transform: "translate(-324.267 -307.2)",
    fill: "CurrentColor"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3231",
    "data-name": "Group 3231",
    transform: "translate(2.495 10.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3230",
    "data-name": "Group 3230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40923",
    "data-name": "Path 40923",
    d: "M86.83,375.467h-1a.5.5,0,1,0,0,1h1a.5.5,0,1,0,0-1Z",
    transform: "translate(-85.333 -375.467)",
    fill: "CurrentColor"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233",
    transform: "translate(5.988 10.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3232",
    "data-name": "Group 3232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40924",
    "data-name": "Path 40924",
    d: "M206.3,375.467h-1a.5.5,0,0,0,0,1h1a.5.5,0,0,0,0-1Z",
    transform: "translate(-204.8 -375.467)",
    fill: "CurrentColor"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    transform: "translate(9.481 10.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40925",
    "data-name": "Path 40925",
    d: "M325.764,375.467h-1a.5.5,0,0,0,0,1h1a.5.5,0,0,0,0-1Z",
    transform: "translate(-324.267 -375.467)",
    fill: "CurrentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4a2b481a.svg";
export { ForwardRef as ReactComponent };